import admin from './admin'

export default [
  ...admin,
  { path: '*', component: () => import('@/views/ErrorPage.vue') }
]
